/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

/*
* -------------------------------------------
*                LOAD CHART
* -------------------------------------------
*/

export const WIDGET_COSTS_LOAD_CHART = '@@b2b_portal_ui/dashboard/widget/WIDGET_COSTS_LOAD_CHART';
export const WIDGET_COSTS_LOAD_CHART_SUCCESSFUL = '@@b2b_portal_ui/dashboard/widget/WIDGET_COSTS_LOAD_CHART_SUCCESSFUL';
export const WIDGET_COSTS_LOAD_CHART_ERROR = '@@b2b_portal_ui/dashboard/widget/WIDGET_COSTS_LOAD_CHART_ERROR';

/*
* -------------------------------------------
*       REDIRECT TO PAYMENTS BASKET
* -------------------------------------------
*/

export const WIDGET_COSTS_REDIRECT_TO_PAYMENTS = '@@b2b_portal_ui/dashboard/widget/WIDGET_COSTS_REDIRECT_TO_PAYMENTS';
export const WIDGET_COSTS_REDIRECT_TO_PAYMENTS_ERROR =
    '@@b2b_portal_ui/dashboard/widget/WIDGET_COSTS_REDIRECT_TO_PAYMENTS_ERROR';
